import React, { useState } from "react";
import {
    LocalizationProvider,
    DatePicker,
} from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import {
    Container,
    Typography,
    TextField,
    Grid,
    Box,
    Button,
    Table,
    TablePagination,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
} from "@mui/material";
import Header from "./../components/Header";
import axios from "../Axiosinstance";
import * as XLSX from 'xlsx';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

const StudentAmountTable = () => {
    const [data, setData] = useState([]); // Initial empty data
    const [filteredData, setFilteredData] = useState([]);
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [page, setPage] = useState(0); // Current page index
    const [rowsPerPage, setRowsPerPage] = useState(20); // Rows per page

    const filterData = async () => {
        if (startDate && endDate) {
            try {
                const formatDate = (date) => {

                    return date ? date.format('YYYY-MM-DD') : '';

                }
                const response = await axios.get(
                    `registrationadvances/api/course-fee-details`, {
                    params: {
                        startDate: formatDate(startDate),
                        endDate: formatDate(endDate),
                    },
                }
                );
                // // Transform the response data into an array of objects
                // const transformedData = response.data.map((item) => ({
                //     studentName: item[0],  // Accessing the name
                //     date: item[1],         // Accessing the date
                //     amount: item[2],       // Accessing the amount
                // }));
                setFilteredData(response.data); // Set filtered data from API response
            } catch (error) {
                console.error("Failed to fetch data", error);
            }
        } else {
            setFilteredData(data);
        }
    };

    const calculateTotal = () =>
        filteredData.reduce((total, item) => total + item.amount, 0);

    // Handle page change
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    // Handle rows per page change
    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    // Data to display on the current page
    const paginatedData = filteredData.slice(
        page * rowsPerPage,
        page * rowsPerPage + rowsPerPage
    );

    const downloadExcel = () => {
        if (filteredData.length === 0) {
            console.warn("No data to export");
            return;
        }
        const formatDate = (dateString) => {
            const date = new Date(dateString);
            const day = String(date.getDate()).padStart(2, '0');
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const year = date.getFullYear();
            return `${day}-${month}-${year}`;
        };

        // Calculate the date range
        const startDate = new Date(Math.min(...filteredData.map((item) => new Date(item.date))));
        const endDate = new Date(Math.max(...filteredData.map((item) => new Date(item.date))));
        const month = startDate.toLocaleString('default', { month: 'long', year: 'numeric' });

        // Define the headers
        const headers = [["S:NO", "Date", "Receipt No", "Name", "Credits"]];

        // Transform data to match the required format
        const transformedData = filteredData.map((item, index) => [
            index + 1, // Serial number
            formatDate(item.date), // Format date
            item.invoiceNumber, // Receipt No
            item.studentName, // Name
            `$${item.amount}`, // Credits
        ]);

        // Add total row
        const totalCredits = filteredData.reduce((sum, item) => sum + item.amount, 0);
        transformedData.push(["", "", "", "TOTAL", `$${totalCredits}`]);

        // Combine headers and data
        const fullData = [[""], [`Monthly Report: ${month}`], [`Date Range: ${startDate.toLocaleDateString()} - ${endDate.toLocaleDateString()}`], ...headers, ...transformedData];

        // Generate the worksheet
        const ws = XLSX.utils.aoa_to_sheet(fullData);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Student Amount Report");

        // Merge the first three rows for better presentation
        ws["!merges"] = [
            { s: { r: 0, c: 0 }, e: { r: 0, c: 4 } }, // Merge first row
            { s: { r: 1, c: 0 }, e: { r: 1, c: 4 } }, // Merge second row
            { s: { r: 2, c: 0 }, e: { r: 2, c: 4 } }, // Merge third row
        ];

        // Style the first three rows
        for (let r = 0; r < 3; r++) {
            const cellAddress = XLSX.utils.encode_cell({ r: r, c: 0 }); // First column of each row
            if (ws[cellAddress]) {
                ws[cellAddress].s = {
                    alignment: { horizontal: "center", vertical: "center" },
                    font: { bold: true, size: 14 },
                };
            }
        }

        // Apply bold styling to the headers
        const headerRange = XLSX.utils.decode_range(ws["!ref"]);
        for (let C = 0; C <= 4; ++C) {
            const cellAddress = XLSX.utils.encode_cell({ r: 3, c: C }); // Header row
            if (!ws[cellAddress]) continue;
            ws[cellAddress].s = { font: { bold: true } }; // Apply bold
        }

        // Write the workbook to an Excel file
        XLSX.writeFile(wb, "Student_Amount_Report.xlsx");
    };


    return (
        <div style={{ marginBottom: '8%' }}>
            <Header />
            <br />
            <br />
            <br />
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <Container>
                    <Typography variant="h4" align="center" gutterBottom>
                        Monthly Payment Report
                    </Typography>
                    <Box my={4}>
                        <Grid container spacing={2}>
                            {/* Start Date */}

                            <Grid item xs={12} sm={3}>
                                <DatePicker
                                    label="Start Date"
                                    value={startDate}
                                    format="DD/MM/YYYY"
                                    onChange={(newValue) => setStartDate(newValue)}
                                    renderInput={(params) => <TextField fullWidth {...params} />}
                                />
                            </Grid>

                            {/* End Date */}
                            <Grid item xs={12} sm={3}>
                                <DatePicker
                                    label="End Date"
                                    value={endDate}
                                    format="DD/MM/YYYY"
                                    onChange={(newValue) => setEndDate(newValue)}
                                    renderInput={(params) => <TextField fullWidth {...params} />}
                                />
                            </Grid>

                            {/* Search Button */}
                            <Grid item xs={12} sm={3}>
                                <Button
                                    variant="contained"
                                    sx={{
                                        backgroundColor: "#007bff",
                                        height: "56px", // Match TextField height
                                        fontSize: "1rem", // Consistent font size
                                        textTransform: "none",
                                    }}
                                    fullWidth
                                    onClick={filterData}
                                >
                                    Search
                                </Button>
                            </Grid>

                            {/* Download Excel Button */}
                            <Grid item xs={12} sm={3}>
                                <Button
                                    variant="contained"
                                    sx={{
                                        backgroundColor: "#007bff",
                                        height: "56px", // Match TextField height
                                        fontSize: "1rem", // Consistent font size
                                        textTransform: "none",
                                    }}
                                    fullWidth
                                    onClick={downloadExcel}
                                >
                                    Download Excel
                                </Button>
                            </Grid>
                        </Grid>
                    </Box>

                    <TableContainer component={Paper}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell style={{ fontWeight: 'bold' }} >Name</TableCell>
                                    <TableCell style={{ fontWeight: 'bold' }} >Date</TableCell>
                                    <TableCell style={{ fontWeight: 'bold' }} >Reciept No</TableCell>
                                    <TableCell style={{ fontWeight: 'bold' }} align="right">Credits</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {paginatedData.length === 0 ? (
                                    <TableRow>
                                        <TableCell colSpan={4} align="center">
                                            <Typography variant="body1"><strong>No Data Available </strong></Typography>
                                        </TableCell>
                                    </TableRow>
                                ) : (
                                    paginatedData.map((row, index) => (
                                        <TableRow key={index}>
                                            <TableCell>{row.studentName}</TableCell>
                                            <TableCell>
                                                {(() => {
                                                    const date = new Date(row.date);
                                                    const day = String(date.getDate()).padStart(2, '0');
                                                    const month = String(date.getMonth() + 1).padStart(2, '0');
                                                    const year = date.getFullYear();
                                                    return `${day}-${month}-${year}`;
                                                })()}
                                            </TableCell>
                                            <TableCell >{row.invoiceNumber}</TableCell>
                                            <TableCell align="right">${row.amount}</TableCell>
                                        </TableRow>
                                    ))
                                )}
                            </TableBody>
                        </Table>
                        <TablePagination
                            rowsPerPageOptions={[5, 15, 25]}
                            component="div"
                            count={filteredData.length}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            onPageChange={handleChangePage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                        />
                    </TableContainer>
                    <Box mt={3} textAlign="right">
                        <Typography variant="h5">
                            Total Amount Received: ${calculateTotal()}
                        </Typography>
                    </Box>
                </Container>
            </LocalizationProvider>
        </div>
    );
};

export default StudentAmountTable;